<ng-container *transloco="let t">

  <ng-container *ngIf="!awards"><img src="/assets/images/loading1.gif" title="Loading" ></ng-container>

  <div class="row" *ngIf="awards">
    <div class="col-12 col-md-6">
      <c-card class="mb-3">
        <c-card-header>
          <b> {{ t('Top Safe Workers for') }} {{month}} </b>
        </c-card-header>
        <c-card-body  *ngIf="awards.top_10_workers.length > 0">


            <table
            [hover]="true"
            [responsive]="true"
            [striped]="true"
            align="middle"
            cTable
            class="mb-0"
            >
              <tr *ngFor="let worker of awards.top_10_workers, let i = index">
                <td>
                  <b>
                  <i class="fa fa-trophy gold" aria-hidden="true" *ngIf="i==0"></i>
                  <i class="fa fa-trophy silver" aria-hidden="true" *ngIf="i==1" ></i>
                  <i class="fa fa-trophy bronze" aria-hidden="true" *ngIf="i==2"></i>
                  &nbsp;{{u.ordinal(i+1)}} - {{worker.score}}</b>
                </td>
                <td>
                  {{worker.name}}
                </td>
                <td>
                    <img src="{{badge.img_url}}" class="badge-img p-0 m-0" *ngFor="let badge of worker.badges">

                </td>
              </tr>
            </table>

        </c-card-body>

      </c-card>

      <c-card class="mb-2" *ngIf="awards.company_certificates.length > 0">
        <c-card-header><b> {{ t('Latest Company Certificates') }}</b></c-card-header>
        <c-card-body class="report-container">
          <div class="row">
            <div class="col-12 col-lg-6" *ngFor="let cert of awards.company_certificates" >
              <img src="{{cert.img_url}}" class="img-fluid img-thumbnail">
            </div>
          </div>
        </c-card-body>
      </c-card>

      <c-card class="mb-2" *ngIf="awards.worker_certificates.length > 0">
        <c-card-header><b> {{ t('Worker Report Cards') }}</b></c-card-header>
        <c-card-body class="report-container">
          <div class="row">
            <div class="col-12 col-lg-6"*ngFor="let cert of awards.worker_certificates" >
            <img src="{{cert.img_url}}" class="img-fluid">
          </div></div>

        </c-card-body>
      </c-card>


    </div>

    <div class="col-12 col-md-6">

      <c-card class="mb-4" *ngIf="awards.company_reportcard">
        <c-card-header><b> {{ t('Company Results for') }} {{month}}</b></c-card-header>
        <c-card-body>
          <img src="{{awards.company_reportcard.img_url}}" class="img-fluid">
        </c-card-body>
      </c-card>

      <c-card class="mb-2" *ngIf="awards.worker_reportcards.length > 0">
        <c-card-header><b> {{ t('Latest Worker Certificates') }}</b></c-card-header>
        <c-card-body class="report-container">
          <div class="row">
            <div class="col-12 col-lg-6" *ngFor="let report of awards.worker_reportcards" >
            <img src="{{report.img_url}}" class="img-fluid">
          </div></div>
        </c-card-body>
      </c-card>

      <div class="text-center">
        <button type="button" class="btn btn-outline-dark m-2" (click)="downloadCertificates()" [disabled]="download">
          <span *ngIf="!download"><i class="fa-solid fa-download"></i> {{ t('Download Certificates') }}</span>
          <span *ngIf="download"><i class="fa-solid fa-spinner fa-spin"></i> {{ t('Please wait...') }}</span>
        </button>
      </div>

      <div class="text-center">
        <button type="button" class="btn btn-outline-dark m-2" (click)="exportAwardStats()" [disabled]="download2">
          <span *ngIf="!download2"><i class="fa-solid fa-download"></i> {{ t('Export Award Stats') }}</span>
          <span *ngIf="download2"><i class="fa-solid fa-spinner fa-spin"></i> {{ t('Please wait...') }}</span>
        </button>
      </div>


    <div class="card">
      <div class="card-body">
      <p>{{ t("Don't want Safety Awards on your account? Please email us at") }} <a href="customer.support@ok-alone.com" target="new">customer.support&#64;ok-alone.com</a> {{ t('and we can disable it for you.') }}</p>
      </div>
    </div>

    </div>
  </div>

  <!-- <c-row>
    <c-col>

    </c-col>
    <c-col>
      <c-card class="mb-2">
        <c-card-header><b> Share Results with all Workers</b></c-card-header>
        <c-card-body>Give workers access to their scores, report cards and certificates. We will send them a unique link they can use to view their results at any time.</c-card-body>
      </c-card>
      <c-card class="mb-2">
        <c-card-header><b> Give OK Alone Permission to Send SMS/eMails to All Workers</b></c-card-header>
        <c-card-body>Give OK Alone permission to send workers their Report Cards and Certificates each month by email or SMS </c-card-body>
      </c-card>
    </c-col>
    </c-row> -->



</ng-container>

